module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isPageReady) ? _c('div', {
    staticClass: "page video-page show-page",
    class: {
      'no-top-nav': !_vm.onMobile,
      onMobile: _vm.onMobile
    }
  }, [_c('div', {
    staticClass: "page-content margin-top-header"
  }, [_c('v-container', {
    class: {
      'grid-list-md px-4': !_vm.onMobile
    },
    attrs: {
      "fluid": "",
      "px-0": ""
    }
  }, [_c('div', {
    staticClass: "vid_col mb-4"
  }, [_c('video-player', {
    attrs: {
      "src": _vm.stream.mp_channel_1_ep_1_url
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(!_vm.onMobile) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm8": "",
      "comment-wrapper": ""
    }
  }, [_c('div', [(_vm.onMobile) ? _c('div', {
    staticClass: "pane-tabs-onMobile"
  }, _vm._l((_vm.paneTabs), function(tab, index) {
    return _c('div', {
      key: index,
      staticClass: "pane-tab",
      class: {
        active: _vm.activePaneTab == tab.id
      },
      on: {
        "click": function($event) {
          _vm.activePaneTab = tab.id
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(tab.name) + " "), (tab.id == 'comments') ? _c('span', [_vm._v("(" + _vm._s(_vm._f("formatLargeNumber")(_vm.comments.length)) + ")")]) : _vm._e()])
  })) : _vm._e(), _vm._v(" "), (_vm.activePaneTab == 'info') ? _c('div', [_c('div', {
    staticClass: "content-section"
  }, [_c('div', {
    staticClass: "meta__content",
    class: {
      'px-4': _vm.onMobile
    }
  }, [(_vm.onMobile) ? _c('user-tag', {
    staticClass: "tag",
    attrs: {
      "showAvatar": "",
      "hideName": "",
      "hideTick": "",
      "clickUser": "",
      "width": "40",
      "height": "40",
      "user": _vm.stream.user
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.onMobile) ? _c('div', {
    staticClass: "meta__title"
  }, [_vm._v(_vm._s(_vm.stream.name))]) : _vm._e(), _vm._v(" "), (_vm.onMobile) ? _c('div', {
    staticClass: "dflex flex-column"
  }, [_c('div', {
    staticClass: "meta__name"
  }, [_vm._v(_vm._s(_vm.stream.name.split('- ')[1] || _vm.stream.name))]), _vm._v(" "), _c('div', {
    staticClass: "meta__title text-capitalize"
  }, [_vm._v(_vm._s(_vm.stream.user.username))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "show-more"
  }, [_c('div', {
    staticClass: "vid__description"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.stream.description) + "\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), (_vm.initShowMore) ? _c('span', {
    staticClass: "app-grey--text cursor-pointer showMoreActive",
    on: {
      "click": function($event) {
        _vm.showMoreActive = !_vm.showMoreActive
      }
    }
  }, [(!_vm.showMoreActive) ? _c('b', {
    staticClass: "show-more-less show-more"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\tSHOW MORE\n\t\t\t\t\t\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.showMoreActive) ? _c('b', {
    staticClass: "show-more-less show-less"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\tSHOW LESS\n\t\t\t\t\t\t\t\t\t\t\t\t")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "divider my-4"
  }), _vm._v(" "), (_vm.stream.user.id === _vm.currentUser.id) ? _c('div', {
    staticClass: "attachment-block",
    on: {
      "click": function($event) {
        (_vm.showAttachProduct = true)
      }
    }
  }, [_c('div', [_c('img', {
    attrs: {
      "src": require("../../assets/bold-plus.svg"),
      "width": "16"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_content"
  }, [_vm._v("Attach content to video")])]) : _vm._e(), _vm._v(" "), (_vm.onMobile) ? _c('div', {
    staticClass: "meta__cta follow"
  }, [(_vm.currentUser && _vm.stream.user.id != _vm.currentUser.id) ? _c('user-follow-btn', {
    attrs: {
      "user": _vm.stream.user,
      "theme": "dark",
      "type": "player"
    }
  }) : _vm._e()], 1) : _vm._e()], 1)])]) : _vm._e()]), _vm._v(" "), _c('comments', {
    attrs: {
      "item": _vm.stream,
      "comments": _vm.comments,
      "roundAvatar": ""
    },
    on: {
      "reRenderComments": _vm.reRenderComments
    }
  })], 1) : _c('v-flex', {
    staticClass: "px-4",
    attrs: {
      "xs12": "",
      "comment-wrapper": ""
    }
  }, [_c('chat', {
    attrs: {
      "items": _vm.comments,
      "hideDatedString": "",
      "showShortAge": ""
    }
  }), _vm._v(" "), _c('comment-input', {
    attrs: {
      "item": _vm.stream,
      "roundInput": "",
      "noBorder": "",
      "placeholder": "Add your reply"
    }
  })], 1), _vm._v(" "), (_vm.activePaneTab == 'info') ? _c('v-flex', {
    staticClass: "related_col",
    class: {
      'pl-4': !_vm.onMobile
    },
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('div', {
    staticClass: "videos-section"
  }, [_c('h4', {
    staticClass: "__title",
    class: {
      'px-2': _vm.onMobile
    }
  }, [_vm._v("Related Videos")]), _vm._v(" "), _c('div', {
    staticClass: "section__content"
  }, _vm._l((_vm.videos), function(video) {
    return _c('div', {
      key: video.name,
      class: {
        side_fullwidth: _vm.onMobile
      }
    }, [_c('video-box', {
      attrs: {
        "hoverOverlay": false,
        "item": video,
        "showUsername": "",
        "hideUser": !_vm.onMobile ? true : false,
        "sideTabView": !_vm.onMobile ? true : false
      }
    })], 1)
  }))])]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "product-attach-dialog"
    },
    model: {
      value: (_vm.showAttachProduct),
      callback: function($$v) {
        _vm.showAttachProduct = $$v
      },
      expression: "showAttachProduct"
    }
  }, [_c('div', {
    staticClass: "product-attach-flex"
  }, [_c('div', {
    staticClass: "w-60"
  }, [_c('div', {
    staticClass: "content-head"
  }, [_vm._v("SELECT CONTENT")]), _vm._v(" "), _c('div', {
    staticClass: "content-options"
  }, [_c('div', {
    staticClass: "_title",
    class: (_vm.selectAttactProduct == 1) ? "active" : null,
    on: {
      "click": function($event) {
        (_vm.selectAttactProduct = 1)
      }
    }
  }, [_vm._v("Music")]), _vm._v(" "), _c('div', {
    staticClass: "_title",
    class: (_vm.selectAttactProduct == 2) ? "active" : null,
    on: {
      "click": function($event) {
        (_vm.selectAttactProduct = 2)
      }
    }
  }, [_vm._v("Products")])]), _vm._v(" "), _c('div', {
    staticClass: "tabs-main"
  }, [((_vm.selectAttactProduct == 1)) ? _c('div', {
    staticClass: "tabs-container"
  }, _vm._l((_vm.albums), function(album, index) {
    return _c('div', {
      staticClass: "tabs-div",
      class: {
        'active': _vm.mainItem.id === album.id
      },
      on: {
        "click": function($event) {
          _vm.mainItem = album
        }
      }
    }, [_c('div', {
      staticClass: "_image"
    }, [_c('img', {
      attrs: {
        "src": album.cover.url,
        "width": "50"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "_text"
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(album.name))]), _vm._v(" "), _c('div', {
      staticClass: "sub mt-1"
    }, [_vm._v(_vm._s(album.user.username))])])])
  })) : _vm._e(), _vm._v(" "), ((_vm.selectAttactProduct == 2)) ? _c('div', {
    staticClass: "tabs-container"
  }, _vm._l((_vm.products), function(product, index) {
    return _c('div', {
      staticClass: "tabs-div",
      class: {
        'active': _vm.mainItem.id === product.id
      },
      on: {
        "click": function($event) {
          _vm.mainItem = product
        }
      }
    }, [_c('div', {
      staticClass: "_image"
    }, [_c('img', {
      attrs: {
        "src": product.covers[0].cover.url,
        "width": "50"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "_text"
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(product.name))]), _vm._v(" "), _c('div', {
      staticClass: "sub mt-1"
    }, [_vm._v(_vm._s(product.merchant.username))])])])
  })) : _vm._e()])]), _vm._v(" "), (_vm.mainItem) ? _c('div', {
    staticClass: "w-40 cursor-pointer"
  }, [_c('div', {
    staticClass: "profile_image"
  }, [_c('img', {
    attrs: {
      "src": _vm.mainItem.category ? _vm.mainItem.covers[0].cover.url : _vm.mainItem.cover.url,
      "width": "100%"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "profile_info my-3"
  }, [(_vm.mainItem.category) ? _c('div', {
    staticClass: "image",
    style: ({
      'background-image': 'url(' + _vm.mainItem.merchant.avatar.url + ')'
    })
  }) : _c('div', {
    staticClass: "image",
    style: ({
      'background-image': 'url(' + _vm.mainItem.user.avatar.url + ')'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.mainItem.category ? _vm.mainItem.merchant.username : _vm.mainItem.user.username))])]), _vm._v(" "), _c('div', {
    staticClass: "product-info "
  }, [(_vm.mainItem.category) ? _c('div', {
    staticClass: "category"
  }, [_vm._v(_vm._s(_vm.mainItem.category.name))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.mainItem.name))]), _vm._v(" "), (_vm.mainItem.price) ? _c('div', {
    staticClass: "price mt-1"
  }, [_vm._v("$" + _vm._s(_vm.mainItem.price))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "time-info mb-4 mt-3"
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("SHOW ATTACHMENT AT:")]), _vm._v(" "), _c('div', {
    staticClass: "timer-outer mt-2"
  }, [_c('div', {
    staticClass: "time-flex"
  }, [_c('div', [_c('span', {
    attrs: {
      "contenteditable": "",
      "id": "showAttachmentHours"
    }
  }, [_vm._v("00")]), _vm._v("hr\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', [_vm._v("\n\t\t\t\t\t\t\t\t:\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', [_c('span', {
    attrs: {
      "contenteditable": "",
      "id": "showAttachmentMinutes"
    }
  }, [_vm._v("00")]), _vm._v("min\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', [_vm._v("\n\t\t\t\t\t\t\t\t:\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', [_c('span', {
    attrs: {
      "contenteditable": "",
      "id": "showAttachmentSeconds"
    }
  }, [_vm._v("00")]), _vm._v("sec\n\t\t\t\t\t\t\t")])])])]), _vm._v(" "), _c('div', {
    staticClass: "button-case"
  }, [_c('v-btn', {
    staticClass: "button-blue ma-0",
    attrs: {
      "blue": "",
      "rounded": ""
    },
    on: {
      "click": function($event) {
        _vm.addContent()
      }
    }
  }, [_vm._v("Add content")])], 1)]) : _vm._e()])]), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "featured-content-dialog"
    },
    model: {
      value: (_vm.show_featured_dialog),
      callback: function($$v) {
        _vm.show_featured_dialog = $$v
      },
      expression: "show_featured_dialog"
    }
  }, [_c('v-card', [_c('v-card-text', [_c('div', {
    staticClass: "headline mb-2"
  }, [_vm._v("Add albmus & products to your video")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('div', {
    staticClass: "mt-3 pa-3",
    staticStyle: {
      "text-align": "left",
      "background-color": "#f8f8f8",
      "border": "1px solid #eee",
      "border-radius": "5px"
    }
  }, [_c('attach', {
    ref: "assocAttach",
    attrs: {
      "dataOnlyMode": ""
    },
    on: {
      "getAssoc": _vm.getAssoc
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "px-4",
    attrs: {
      "dark": "",
      "round": "",
      "color": "blue"
    },
    nativeOn: {
      "click": function($event) {
        _vm.updateStream()
      }
    }
  }, [_vm._v("Update")]), _vm._v(" "), _c('v-btn', {
    staticClass: "px-4",
    attrs: {
      "dark": "",
      "round": "",
      "color": "grey"
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeFeaturedDialog()
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-spacer')], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.show_payment_dialog),
      callback: function($$v) {
        _vm.show_payment_dialog = $$v
      },
      expression: "show_payment_dialog"
    }
  }, [(_vm.show_payment_dialog) ? _c('payment-modal', {
    attrs: {
      "receivers": [_vm.stream.user],
      "amount": _vm.amount,
      "dismiss": _vm.closePaymentDialog,
      "finish": _vm.payAttachment
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.showSendLoveModal) ? _c('send-love-modal', {
    attrs: {
      "item": _vm.user,
      "dismiss": _vm.dismissLoveDialog
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_share_dialog) ? _c('share-modal', {
    attrs: {
      "item": _vm.stream,
      "type": "Stream",
      "dismiss": _vm.closeShareDialog
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showMerchModal) ? _c('merch-modal', {
    attrs: {
      "item": _vm.stream.assoc,
      "dismiss": _vm.dimissMerchDialog
    }
  }) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    staticStyle: {
      "margin-top": "3%"
    },
    attrs: {
      "content-class": ["finish-modal upload-finish-dialog"]
    },
    model: {
      value: (_vm.showReleaseVideoModal),
      callback: function($$v) {
        _vm.showReleaseVideoModal = $$v
      },
      expression: "showReleaseVideoModal"
    }
  }, [(_vm.showReleaseVideoModal) ? _c('album-finish-modal', {
    attrs: {
      "item": _vm.releaseVideo,
      "type": "stream",
      "promote": _vm.showPromoteModal,
      "dismiss": _vm.dismissFinishDialog
    }
  }) : _vm._e()], 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9218fa08","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/video/show.vue
// module id = 1812
// module chunks = 180